export const walkthrough = {
    state: {
        active: false
    },
    mutations: {
        SET_WALKTHROUGH_ACTIVE(state, payload) {
            state.active = payload
        }
    },
    actions: {
        setWalkthroughActive({ commit }, payload) {
            commit('SET_WALKTHROUGH_ACTIVE', payload)
        }
    },
    getters: {
        getWalkthroughActive: state => {
            return state.active
        }
    }
}
